<template>

    <v-app id="inspire">
        <v-layout row justify-center>
            <v-dialog v-model="onShow" persistent max-width="45%">
                <v-card>
                    <v-card-title>
                        <span class="subheading">MARS - MAC-Pool: {{ macPool.name }}</span>
                    </v-card-title>

                    <v-divider></v-divider>


                    <v-container grid-list-xs style="overflow-y: auto; margin-top: -20px">
                        <v-layout wrap>
                            <v-flex class="modal-flex-height" xs12 sm5>
                                <v-subheader>MAC-Pool ID</v-subheader>
                            </v-flex>

                            <v-flex class="modal-flex-height compact-form" xs12 sm7>
                                <v-text-field
                                        id="modify_pool_id_field"
                                        v-model="macPool.poolId"
                                        color="grey darken-2"
                                        :disabled="true"
                                        class="text-xs-left"
                                ></v-text-field>
                            </v-flex>


                            <v-flex xs6 sm4 md5 class="modal-flex-height">
                                <v-subheader>OUI</v-subheader>
                            </v-flex>
                            <v-flex xs6 sm8 md7 class="modal-flex-height compact-form">
                                <v-text-field
                                        id="modify_pool_oui_field"
                                        name="oui"
                                        v-model="macPool.oui"
                                        color="grey darken-2"
                                        :disabled="entryDisabled"
                                        v-validate="{ max:8, required: true, regex: /[0-9a-fA-F:-]$/ }"
                                        :error-messages="errors.first('oui')"
                                ></v-text-field>
                            </v-flex>


                            <v-flex xs12 sm8 md5 class="modal-flex-height">
                                <v-subheader>Name</v-subheader>
                            </v-flex>
                            <v-flex xs12 sm8 md7 class="modal-flex-height compact-form">
                                <v-text-field
                                        id="modify_pool_name_field"
                                        name="name"
                                        v-model="macPool.name"
                                        color="grey darken-2"
                                        :disabled="entryDisabled"
                                        v-validate="{required: true}"
                                        :error-messages="errors.first('name')"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm8 md5 class="modal-flex-height">
                                <v-subheader>Description</v-subheader>
                            </v-flex>
                            <v-flex xs12 sm8 md7 class="modal-flex-height compact-form">
                                <v-text-field
                                        id="modify_pool_description_field"
                                        name="description"
                                        v-model="macPool.description"
                                        color="grey darken-2"
                                        :disabled="entryDisabled"
                                        v-validate="{required: true}"
                                        :error-messages="errors.first('description')"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm8 md5 class="modal-flex-height">
                                <v-subheader>Start MAC</v-subheader>
                            </v-flex>
                            <v-flex xs12 sm8 md7 class="modal-flex-height compact-form">
                                <v-text-field
                                        id="modify_pool_start_mac_field"
                                        name="startMac"
                                        vid="startMacAddress"
                                        v-model="macPool.startMac"
                                        color="grey darken-2"
                                        :disabled="entryDisabled"
                                        v-validate="{ max:8, required: true, regex: /[0-9a-fA-F:-]$/ }"
                                        :error-messages="errors.first('startMac')"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm8 md5 class="modal-flex-height">
                                <v-subheader>End MAC</v-subheader>
                            </v-flex>
                            <v-flex xs12 sm8 md7 class="modal-flex-height compact-form">
                                <v-text-field
                                        id="modify_pool_end_mac_field"
                                        name="endMac"
                                        v-model="macPool.endMac"
                                        color="grey darken-2"
                                        :disabled="entryDisabled"
                                        v-validate="{ max:8, required: true, regex: /[0-9a-fA-F:-]$/ }"
                                        :error-messages="errors.first('endMac')"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm8 md5 class="modal-flex-height">
                                <v-subheader>Next MAC</v-subheader>
                            </v-flex>
                            <v-flex xs12 sm8 md7 class="modal-flex-height compact-form">
                                <v-text-field
                                        id="modify_pool_next_mac_field"
                                        name="nextMac"
                                        v-model="macPool.nextMac"
                                        color="grey darken-2"
                                        :disabled="entryDisabled"
                                        v-validate="{ max:8, regex: /[0-9a-fA-F:-]$/, nextMacVerification:macPool.startMac}"
                                        :error-messages="errors.first('nextMac')"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm8 md5 class="modal-flex-height">
                                <v-subheader>Available</v-subheader>
                            </v-flex>
                            <v-flex xs12 sm8 md7 class="modal-flex-height compact-form">
                                <v-text-field
                                        id="modify_pool_available_field"
                                        v-model="macPool.available"
                                        color="grey darken-2"
                                        :disabled="true"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm8 md5 class="modal-flex-height">
                                <v-subheader>Available [%]</v-subheader>
                            </v-flex>
                            <v-flex xs12 sm8 md7 class="modal-flex-height compact-form">
                                <v-text-field
                                        id="modify_pool_available_in_percent_field"
                                        v-model="macPool.availableInPercent"
                                        color="grey darken-2"
                                        :disabled="true"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm8 md5 class="modal-flex-height">
                                <v-subheader>Capacity</v-subheader>
                            </v-flex>
                            <v-flex xs12 sm8 md7 class="modal-flex-height compact-form">
                                <v-text-field
                                        id="modify_pool_capacity_field"
                                        v-model="macPool.capacity"
                                        color="grey darken-2"
                                        :disabled="true"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm8 md5 class="modal-flex-height">
                                <v-subheader>Is Active?</v-subheader>
                            </v-flex>
                            <v-flex xs12 sm8 md7 class="modal-flex-height compact-form">
                                <v-checkbox
                                        id="modify_pool_is_active_checkbox"
                                        v-model="macPool.isActive"
                                        :disabled="entryDisabled"
                                        small
                                ></v-checkbox>
                            </v-flex>

                            <v-flex xs12 sm8 md5 class="modal-flex-height">
                                <v-subheader>Max. MACs per Request</v-subheader>
                            </v-flex>
                            <v-flex xs12 sm8 md7 class="modal-flex-height compact-form">
                                <v-text-field
                                        id="modify_pool_max_macs_per_req_field"
                                        name="maxMacsPerReq"
                                        v-model="macPool.macsPerReq"
                                        color="grey darken-2"
                                        :disabled="entryDisabled"
                                        v-validate="{ regex: /[0-9]$/ }"
                                        :error-messages="errors.first('maxMacsPerReq')"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm8 md5 class="modal-flex-height">
                                <v-subheader>Max. MACs per User and Day</v-subheader>
                            </v-flex>
                            <v-flex xs12 sm8 md7 class="modal-flex-height compact-form">
                                <v-text-field
                                        id="modify_pool_macs_per_user_day_field"
                                        v-model="macPool.macsPerUserDay"
                                        name="macsPerUserDay"
                                        color="grey darken-2"
                                        :disabled="entryDisabled"
                                        v-validate="{ regex: /[0-9]$/ }"
                                        :error-messages="errors.first('macsPerUserDay')"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>


                    <v-alert :value="error" type="error" transition="scale-transition">
                        {{ errorMessage }}
                    </v-alert>


                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn id="modify_pool_save_button" class="text-none" color="green" small dark @click="onSaveMacPool"
                               :disabled="entryDisabled">Save
                        </v-btn>
                        <v-btn id="modify_pool_cancel_button" class="text-none" small @click="close">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-app>
</template>

<script>

    import poolinterface from "../../../interfaces/poolinterface";
    import {EventBus} from "../../../eventbus";
    import {Validator} from 'vee-validate';
    import errormessagemanager from "../../../managers/errormessagemanager";
    import macaddressservice from "../../../services/macaddressservice";

    export default {
        name: 'ShowMacPoolModal',

        data: () => ({
            error: false,
            errorMessage: null
        }),

        props: {
            value: Boolean,
            entryDisabled: Boolean,
            isEditMode: Boolean,

            macPool: {
                poolId: Number,
                oui: String,
                name: String,
                description: String,
                startMac: String,
                endMac: String,
                nextMac: String,
                capacity: Number,
                available: Number,
                availableInPercent: Number,
                isActive: Boolean,
                macsPerReq: Number,
                macsPerUserDay: Number,
                rowVersion: Array
            }
        },

        computed: {
            onShow: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },

        methods: {

            async onSaveMacPool() {
                this.clearAlert();

                this.$validator.validateAll().then(async result => {
                    if (result) {
                        let response = null;

                        if (!this.isEditMode) {
                            await poolinterface.postMacPool(this.macPool, res => {
                                response = res;
                            });
                        } else {
                            await poolinterface.putMacPool(this.macPool, res => {
                                response = res;
                            });
                        }

                        if (response != null && response.error) {
                            if (!this.editMode) {
                                errormessagemanager.getInsertErrorMessage(response.status, message => {
                                    this.errorMessage = message;
                                });
                                this.error = response.error;
                            } else {
                                errormessagemanager.getUpdateErrorMessage(response.status, message => {
                                    this.errorMessage = message;
                                });
                                this.error = response.error;
                            }
                        } else if (!this.error) {
                            await this.close();
                            await EventBus.$emit('macPoolDialogClosed');
                        }
                    }
                });
            },

            async close() {
                await EventBus.$emit('macPoolDialogClosed');
                this.onShow = false;
                this.$emit('close');

                this.clearData();
            },

            clearData() {
                this.macPool.poolId = null;
                this.macPool.oui = null;
                this.macPool.name = null;
                this.macPool.description = null;
                this.macPool.startMac = null;
                this.macPool.endMac = null;
                this.macPool.nextMac = null;
                this.macPool.isActive = false;
                this.macPool.macsPerReq = null;
                this.macPool.macsPerUserDay = null;

                this.clearAlert();

                this.$validator.errors.clear();
                this.$validator.fields.items.forEach(field => field.reset());
                this.$validator.fields.items.forEach(field => this.errors.remove(field));
                this.$validator.resume();
            },

            clearAlert() {
                this.error = false;
                this.errorMessage = false;
            }
        }
    }

    Validator.extend('nextMacVerification', {
        getMessage: () => 'NextMac has to be greater than or equal to StartMac.',
        validate: (value, [secondValue]) => macaddressservice.isFirstMacAddressGreaterThanOrEqualToSecondMacAddress(value, secondValue)
    }, {
        hasTarget: true
    });
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/macpools/modals/ShowMacPoolModal.vue